import styled from 'styled-components';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton/styledButton';
import InputSimple, { phoneDecorator, nameDecorator } from '@ertelecom/ui-react/components/inputSimple';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import InputInstance from '@ertelecom/ui-react/components/input';

const InputPhone = phoneDecorator(InputSimple);
const InputName = nameDecorator(InputSimple);

export const Wrapper = styled.form`
    display: block;
    max-width: 720px;
    color: ${p => p.textColor ? p.textColor : 'inherit'};
`;

export const Title = styled.h2`
    display: block;
    font-size: 24px;
    line-height: 1.33;
    font-family: ${FONTS.regular};
    margin-bottom: 36px;
    @media (max-width: 1279px) {
        margin-right: 20px;
        margin-bottom: 24px;
    }
    @media screen and (max-width: 859px) {
        font-size: 20px;
        margin-bottom: 24px;
    }
`;

export const Inputs = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 16px;
    @media screen and (max-width: 859px) {
        display: block;
        width: 288px;
    }
    @media (max-width: 360px) {
        width: 100%;
        margin-bottom: 20px;
    }
`;

export const Name = styled(InputName)`
    display: block;
    width: ${p => p.formEmail ? 'calc(33% - 20px)' : 'calc(55% - 20px)'};
    margin-right: 20px;
    @media (max-width: 1279px) {
        width: calc(50% - 8px);
    }
    @media screen and (max-width: 859px) {
        width: 100%;
        margin-bottom: 16px;
    }
`;

export const Phone = styled(InputPhone)`
    display: block;
    width: ${p => p.formEmail ? 'calc(33% - 20px)' : '45%'};
    margin-right: ${p => p.formEmail ? '20px' : '0'};
    @media (max-width: 1279px) {
        width: calc(50% - 8px);
    }
    @media screen and (max-width: 859px) {
        width: 100%;
        margin-bottom: 16px;
    }
`;

export const Email = styled(InputInstance)`
    color: ${COLORS.black};
    display: block;
    width: 33%;
    @media (max-width: 1279px) {
        width: calc(50% - 8px);
    }
    @media screen and (max-width: 859px) {
        width: 100%;
        margin-bottom: 16px;
    }
`;

export const ButtonBlock = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    @media screen and (max-width: 859px) {
        width: 288px;
    }
    @media (max-width: 360px) {
        width: 100%;
    }
`;

export const Agree = styled.div`
    display: block;
    width: calc(100% - 308px);
    padding-left: 21px;
    font-size: 14px;
    font-family: ${FONTS.light};
    font-weight: 300;
    line-height: 18px;
    a {    
        display: inline-block;
        border-bottom: 1px solid ${p => p.textColor ? p.textColor : COLORS.black};
        color: ${p => p.textColor ? p.textColor : COLORS.black};
    }
    @media (max-width: 1279px) {
        width: calc(100% - 254px);
    }
    @media screen and (max-width: 859px) {
        width: 100%;
        padding-left: 0;
    }
`;

export const Button = styled(StyledButton)`
    display: block;
    width: 308px;
    @media (max-width: 1279px) {
        width: 254px;
    }
    @media screen and (max-width: 859px) {
        width: 100%;
        margin-bottom: 10px;
    }
`;

export const Message = styled.div`
    display: block;
    width: 100%;
    font-size: 24px;
    font-family: ${FONTS.regular};
    line-height: 1.33;
    p {
        margin: 15px 0;
    }
    a {
        font-family: ${FONTS.regular};
        color: ${COLORS.lightBlue};
    }
`;
